module.exports = __webpack_public_path__ + "img/b_intro_5_en.f715adb.png";